import React, { useState, useEffect } from "react";
import { apiFetch } from "../utils/api";
import { useNotifications } from "./NotificationProvider";

const EventForm = ({ onCreated, year }) => {
  const { showNotification } = useNotifications();
  const [name, setName]         = useState("");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate]     = useState("");

  useEffect(() => {
    if (year) {
      const defaultDate = `${year}-01-01`;
      setStartDate(defaultDate);
      setEndDate(defaultDate);
    }
  }, [year]);

  const submit = async (e) => {
    e.preventDefault();
    if (startDate > endDate) {
      showNotification("error", "Das Enddatum darf nicht vor dem Startdatum liegen.");
      return;
    }
    try {
      const { id } = await apiFetch("/api/events", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ name, start_date: startDate, end_date: endDate })
      });
      onCreated({ id, name, start_date: startDate, end_date: endDate });
      showNotification("success", "Event wurde angelegt.");
    } catch (err) {
      console.error(err);
      if (!err.sessionExpired) showNotification("error", err.message);
    }
  };

  return (
    <form onSubmit={submit}>
      <input
        type="text"
        placeholder="Event-Name"
        value={name}
        onChange={e => setName(e.target.value)}
        required
      />
      <input
        type="date"
        min={`${year}-01-01`} max={`${year}-12-31`}
        value={startDate}
        onChange={e => setStartDate(e.target.value)}
        required
      />
      <input
        type="date"
        min={`${year}-01-01`} max={`${year}-12-31`}
        value={endDate}
        onChange={e => setEndDate(e.target.value)}
        required
      />
      <button type="submit">Event anlegen</button>
    </form>
  );
};

export default EventForm;
